/**
 * @generated SignedSource<<fdcd01056c4a53adb6b7134e19be5d38>>
 * @relayHash 031679929b9f6015bee87c0e9276964c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 05395b00ac0e7e6656e7091c67274e330a0d5586adb2fcf107ad45e1adbf8d50

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphStoreCreateProjectHasRelatedWorkWithProjectInput = {
  relationships: ReadonlyArray<GraphStoreCreateProjectHasRelatedWorkWithProjectRelationshipInput>;
};
export type GraphStoreCreateProjectHasRelatedWorkWithProjectRelationshipInput = {
  from: string;
  sequenceNumber?: AGG$Long | null | undefined;
  to: string;
  updatedAt?: AGG$DateTime | null | undefined;
};
export type useConnectExternalProjectMutation$variables = {
  input?: GraphStoreCreateProjectHasRelatedWorkWithProjectInput | null | undefined;
};
export type useConnectExternalProjectMutation$data = {
  readonly graphStore: {
    readonly createProjectHasRelatedWorkWithProject: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useConnectExternalProjectMutation = {
  response: useConnectExternalProjectMutation$data;
  variables: useConnectExternalProjectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useConnectExternalProjectMutation",
    "selections": [
      {
        "concreteType": "GraphStoreMutation",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "GraphStoreCreateProjectHasRelatedWorkWithProjectPayload",
            "kind": "LinkedField",
            "name": "createProjectHasRelatedWorkWithProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useConnectExternalProjectMutation",
    "selections": [
      {
        "concreteType": "GraphStoreMutation",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "GraphStoreCreateProjectHasRelatedWorkWithProjectPayload",
            "kind": "LinkedField",
            "name": "createProjectHasRelatedWorkWithProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "05395b00ac0e7e6656e7091c67274e330a0d5586adb2fcf107ad45e1adbf8d50",
    "metadata": {},
    "name": "useConnectExternalProjectMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "30faee431fafd14256d6f92cfe73f8bf";

export default node;
